import React from 'react';
import { useLocation } from 'react-router-dom';
import { Play } from 'lucide-react';
import { useDashboardTour } from './DashboardTour';
import { useSettingsTour } from './SettingsTour';
import { useManageScansTour } from './ManageScansTour';
import { useIntegrationTour } from './IntegrationTour';

const TourButton = () => {
  const location = useLocation();
  const { startTour: startDashboardTour } = useDashboardTour(false);
  const { startTour: startSettingsTour } = useSettingsTour(false);
  const { startTour: startManageScansTour } = useManageScansTour(false);
  const { startTour: startIntegrationTour } = useIntegrationTour(false);

  // Define pages that have tours
  const pagesWithTours = {
    '/': startDashboardTour,
    '/dashboard': startDashboardTour,
    '/settings': startSettingsTour,
    '/manage-scans': startManageScansTour,
    '/integration': startIntegrationTour,
  };

  // Find the matching tour function for current route
  const getTourFunction = () => {
    // Check exact match first
    if (pagesWithTours[location.pathname]) {
      return pagesWithTours[location.pathname];
    }
    
    // Check if pathname starts with any tour route
    for (const [route, tourFunction] of Object.entries(pagesWithTours)) {
      if (location.pathname.startsWith(route) && route !== '/') {
        return tourFunction;
      }
    }
    
    return null;
  };

  const startTour = getTourFunction();

  // Don't render button if no tour is available for this page
  if (!startTour) {
    return null;
  }

  return (
    <button
      onClick={startTour}
      className="fixed top-6 right-6 z-[9999] bg-[#44087D] text-white rounded-full shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-110 flex items-center gap-2 px-4 py-3 font-medium text-sm hover:bg-[#5a0ba3]"
      aria-label="Start guided tour"
    >
      <Play className="w-4 h-4" fill="currentColor" />
      <span>Start Tour</span>
    </button>
  );
};

export default TourButton;
